<template>
  <div>
    <div class="page page__list" v-if="params.category == 10">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="params.category == 30">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="params.category == 20">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="params.category == 40">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import Session from "@/util/session.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      listUrl: "/api/sale/saledown/listData",
      params: {
        fromDate: 1640966400000,
        endDate: 1672502399000,
        keyword: '',
        category: 10,
        pageNumber: 1,
        pageSize: 14,
        page: 1,
        start: 0,
        limit: 14
      },
      items: [],
      filters: [
        {
          type: "date",
          // name: "fa_date"
        },
        {
          // type: "condition",
          label: "单据名称",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "采购订单"
            },
            {
              value: 1,
              label: "采购订单变更"
            },
            {
              value: 2,
              label: "外协订单"
            },
            {
              value: 3,
              label: "外协订单变更"
            },
          ]
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
      vm.search();
    });
  },
  methods: {
    init() {
      let session = Session.get()
      if(session && session.appId === 'trade-app' && this.filters[1].options.length == 4) {
        this.filters[1].options = [this.filters[1].options[0], this.filters[1].options[1]]
      } else if(session && session.appId === 'make-app' && this.filters[1].options.length == 2) {
        this.filters[1].options = this.filters[1].options.concat([            
          {value: 2, label: "外协订单"},
          {value: 3, label: "外协订单变更"}
        ])
      }
    },
    beforeFilterChange(filter, filterBar, next) {
      if(filter.value == -1)this.params.category = 10
      if(filter.value == 1)this.params.category = 30
      if(filter.value == 2)this.params.category = 20
      if(filter.value == 3)this.params.category = 40
      filterBar.initConfig()
      next()
    },
    search() {
      var me = this
      me.params.keyword = me.$refs.searchBar.getValue()
      let filterBar = me.$refs.filterBar
      let dateFilter = me.$refs.filterBar.parsedFilters[0]
      let period = dateFilter.fn(dateFilter.value, dateFilter, filterBar).value.split(',')
      let fromDate = period[0].split(/-|\s|:/)
      let endDate = period[1].split(/-|\s|:/)
      fromDate[1]--
      endDate[1]--
      me.params.fromDate = new Date(...fromDate).getTime()
      me.params.endDate = new Date(...endDate).getTime()
      me.$loading({
        url: me.listUrl,
        params: me.params
      }).then(function (res) {
        if (res.success) {
          me.items = res.data.content || res.data || []
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    gotoView(item) {
      let name
      if(this.params.category == 10)name = "SaleB2BDetailPurchase"
      if(this.params.category == 30)name = "SaleB2BDetailPurchaseChange"
      if(this.params.category == 20)name = "SaleB2BDetailOsmake"
      if(this.params.category == 40)name = "SaleB2BDetailOsmakeChange"
      item.sa_category = this.params.category
      this.$router.push({
        name,
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  }
}
</script>